import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const courseSize = { limit: 3 }

const FeaturedCourses = ({featuredCourses}) => {
    const navigate = useNavigate();
    const configData = useSelector((state) => state.configSlice);
    const userData = useSelector((state) => state.userSlice);
    const isLoggedIn = userData.token.length > 0 ? true : false;
    const [featured, setFeatured] = useState([])

    const getExploreModuleList = async () => {
        try {
            const { data } = await axios.get(`${configData.config.API_URL}/api/module/all${configData.config.MODE}`, {
                params: {...courseSize, applicationId : configData.config.applicationId},
                headers: {
                    Authorization: `Bearer`,
                }});
            setFeatured(data.data)
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getExploreModuleList();
    }, [isLoggedIn]);

    return (
        <>
            <div className="featucourses">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-7 text-center">
                            <h4 className='text-danger' dangerouslySetInnerHTML={{ __html: featuredCourses?.heading}} />
                            <p dangerouslySetInnerHTML={{ __html: featuredCourses?.paragraph}} />
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <div className="row">
                                {featured.length > 0 &&
                                    featured.map((e, i) => {
                                        return (
                                            <div className="col-md-4">
                                                <div className="tilecard for-featured">
                                                    <div className="course-card">
                                                        <div className="projectthumb"><img src={e.versions[0].data.thumbnail} alt="0" /></div>
                                                        <div className="card-body-main">
                                                            <p aria-label="Masterclass: Exploring XR Technologies and Content Libraries" className="" data-mui-internal-clone-element="true" dangerouslySetInnerHTML={{ __html: e.name }} />
                                                        </div>
                                                        <div className="card-body-des">
                                                            <p aria-label="Our XR Masterclass offers a comprehensive exploration of Extended Reality (XR) technology and content libraries over two immersive days." className="" data-mui-internal-clone-element="true" dangerouslySetInnerHTML={{ __html: e.versions[0].data.short }} />
                                                        </div>
                                                        <div className="devicelist"></div>
                                                        <div className="card-footer p-1 ">
                                                            <div className="row">
                                                                <div className="col-12 text-center p-0 px-2">
                                                                    <button onClick={()=> navigate(`/course/details/${e.uuid}`)} className="gotocourse">
                                                                        Go To Course
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
                                                                            <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"></path>
                                                                        </svg>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FeaturedCourses
